"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "patient-card" };
var _hoisted_2 = { class: "card-header" };
var _hoisted_3 = { class: "header-info" };
var _hoisted_4 = { class: "patient-name" };
var _hoisted_5 = { class: "mrn" };
var _hoisted_6 = { class: "menu-container" };
var _hoisted_7 = {
    key: 1,
    class: "menu-dropdown"
};
var _hoisted_8 = { class: "card-body" };
var _hoisted_9 = { class: "info-row" };
var _hoisted_10 = { class: "info-text" };
var _hoisted_11 = ["href"];
var _hoisted_12 = { class: "info-row" };
var _hoisted_13 = { class: "info-text" };
var _hoisted_14 = ["href"];
var _hoisted_15 = { class: "info-row" };
var _hoisted_16 = { class: "info-text email-text" };
var _hoisted_17 = { class: "info-row address-row" };
var _hoisted_18 = { class: "info-text" };
var _hoisted_19 = { class: "info-row address-row" };
var _hoisted_20 = { class: "info-text email-text verify-patprovider" };
var _hoisted_21 = { class: "info-row address-row" };
var _hoisted_22 = { class: "info-text" };
var _hoisted_23 = { class: "info-row address-row" };
var _hoisted_24 = { class: "info-text" };
var _hoisted_25 = { class: "card-footer" };
var vue_3 = require("vue");
//import axios from 'axios';
//import { CURR_API } from "@/constants/apis";
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProviderCard',
    props: {
        patprovider: {}
    },
    emits: ["edit", "email", "sms", "call"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var todaydt = new Date();
        var showMenu = (0, vue_3.ref)(false);
        /*const initials = computed(() => {
          return `${props.patient.firstName[0]}${props.patient.lastName[0]}`.toUpperCase()
        })*/
        // Computed property for initials
        var initials = (0, vue_3.computed)(function () {
            var firstInitial = props.patprovider.firstName ? props.patprovider.firstName[0] : '';
            var lastInitial = props.patprovider.lastName ? props.patprovider.lastName[0] : '';
            return "".concat(firstInitial).concat(lastInitial).toUpperCase();
        });
        function formatDateToYYYYMMDD(d) {
            return (d.getFullYear() +
                '-' +
                String(d.getMonth() + 1).padStart(2, '0') +
                '-' +
                String(d.getDate()).padStart(2, '0'));
        }
        function handleEditClick() {
            showMenu.value = false;
            emit('edit', props.patprovider);
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", {
                        class: "avatar",
                        style: (0, vue_2.normalizeStyle)({ background: _ctx.patprovider.avatarColor })
                    }, (0, vue_2.toDisplayString)(initials.value), 5),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("h3", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.patprovider.lastName) + ", " + (0, vue_2.toDisplayString)(_ctx.patprovider.firstName), 1),
                        (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(_ctx.patprovider.arn), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "menu-btn",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (showMenu.value = !showMenu.value); })
                        }, __spreadArray([], (_cache[5] || (_cache[5] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-option-vertical bi-three-dots-vertical" }, null, -1)
                        ])), true)),
                        (showMenu.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: "menu-backdrop",
                                onClick: _cache[1] || (_cache[1] = function ($event) { return (showMenu.value = false); })
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (showMenu.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: "menu-item",
                                    onClick: handleEditClick
                                }, __spreadArray([], (_cache[6] || (_cache[6] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil bi-pencil" }, null, -1),
                                    (0, vue_2.createTextVNode)(" Edit Demographics ", -1)
                                ])), true))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-phone" }, "Phone", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_10, [
                            (0, vue_2.createElementVNode)("a", {
                                href: 'tel:' + _ctx.patprovider.phone + '',
                                title: "Provider Phone"
                            }, (0, vue_2.toDisplayString)(_ctx.patprovider.phone), 9, _hoisted_11)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                        _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-phone" }, "Cell", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_13, [
                            (0, vue_2.createElementVNode)("a", {
                                href: 'tel:' + _ctx.patprovider.mobile + '',
                                title: "Provider Phone"
                            }, (0, vue_2.toDisplayString)(_ctx.patprovider.mobile), 9, _hoisted_14)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_15, [
                        _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope" }, "Email:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(_ctx.patprovider.email), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                        _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-map-marker" }, "Address:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_18, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.patprovider.address.street), 1),
                            _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("br", null, null, -1)),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.patprovider.address.city) + ", " + (0, vue_2.toDisplayString)(_ctx.patprovider.address.state) + " " + (0, vue_2.toDisplayString)(_ctx.patprovider.address.zip), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_19, [
                        _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "NPI Number:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_20, (0, vue_2.toDisplayString)(_ctx.patprovider.npinumber), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                        _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "Fax:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_22, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.patprovider.fax), 1),
                            _cache[13] || (_cache[13] = (0, vue_2.createElementVNode)("br", null, null, -1))
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_23, [
                        _cache[16] || (_cache[16] = (0, vue_2.createElementVNode)("span", { class: "bi bi-status" }, "Status:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_24, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.patprovider.status), 1),
                            _cache[15] || (_cache[15] = (0, vue_2.createElementVNode)("br", null, null, -1))
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_25, [
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action email-action",
                        onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.$emit('email', _ctx.patprovider)); })
                    }, __spreadArray([], (_cache[17] || (_cache[17] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope" }, null, -1),
                        (0, vue_2.createTextVNode)(" Email ", -1)
                    ])), true)),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action sms-action",
                        onClick: _cache[3] || (_cache[3] = function ($event) { return (_ctx.$emit('sms', _ctx.patprovider)); })
                    }, __spreadArray([], (_cache[18] || (_cache[18] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment" }, null, -1),
                        (0, vue_2.createTextVNode)(" Text ", -1)
                    ])), true)),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action call-action",
                        onClick: _cache[4] || (_cache[4] = function ($event) { return (_ctx.$emit('call', _ctx.patprovider)); })
                    }, __spreadArray([], (_cache[19] || (_cache[19] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment bi-phone" }, null, -1),
                        (0, vue_2.createTextVNode)(" Call ", -1)
                    ])), true))
                ])
            ]));
        };
    }
});
